import { deleteApi, getApi } from '../../utils/api';
import { IGeneralPractice } from './getGeneralPractices';

export interface IAppointmentSubOutcome {
  consultationSubOutcomeId: number;
  consultationSubOutcomeDescription: string;
}
export interface IAppointmentOutcome {
  appointmentId: number;
  consultationOutcomeId: number;
  otherText: string;
  consultationOutcomeDescription: string;
  subOutcome?: IAppointmentSubOutcome;
}

interface IUser {
  forename: string;
  surname: string;
  azureUserName: string;
  createdDate: Date;
}

export interface IAppointment {
  user: IUser;
  organisation: IGeneralPractice;
  consultationDate: string;
  referralSourceId: number;
  modeOfContactId: number;
  consultationTypeId: number;
  dateCreated: string;
  appointmentConsultationOutcomeList: IAppointmentOutcome[];
  doubleAppointmentFlag: boolean;
  didNotAttendFlag: boolean;
  lateCancellationFlag: boolean;
  interpreterRequiredFlag: boolean;
  appointmentId: number;
  referralSourceDescription: string;
  modeOfContactDescription: string;
  consultationTypeDescription: string;
  followUpMethodId: number;
  followUpMethodDescription: string;
  followUpReasonId: number;
  followUpReasonDescription: string;
  patientAgeRangeId: number;
  patientAgeRangeDescription: string;
  doubleAppointmentReasonId: number;
  doubleAppointmentReasonDescription: string;
}

export const getAppointments = (
  numOfAppointmentsDisplayed: string,
  startDate: string,
  endDate: string
) =>
  getApi<IAppointment[]>(
    `appointments/?count=${numOfAppointmentsDisplayed}&startDate=${startDate}&endDate=${endDate}`
  );

export const deleteAppointment = (appointmentId: number) =>
  deleteApi<unknown>(`appointments/${appointmentId}`);
